// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../../factories/tab-page";
import BaoDialogViewModel from "./../../factories/bao-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/sorting";
import AppTabController from "../../services/app-tab-controller";
function RoleServiceProviderTabModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.Role = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.ServiceProviderCollection = ko.observableArray([]);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteRoleServiceProvider");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddServiceProviderToRole":
                self.ShowRoleServiceProviderDialog();
                break;
            case "RemoveServiceProviderFromRole":
                if (self.SelectedServiceProviderRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteRoleServiceProvider(self.SelectedServiceProviderRow().OpenData);
                        }
                    });
                }
                break;
        }
    };
    self.SelectedServiceProviderId = ko.observable();
    self.SelectedServiceProvider = ko.observable();
    self.SelectedServiceProvider.subscribe(function () {
        self.AddRoleServiceProvider(self.SelectedServiceProviderId(), self.Role.RoleId());
    });
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("UadmCustom/RoleTab/GetRoleServiceProviderCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedServiceProviderRow(null);
            self.TotalRows(0);
            self.ServiceProviderCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.ServiceProviderCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            self.ToggleToolbarButtons();
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddRoleServiceProvider = function (serviceProviderId, roleId) {
        tabPage.IsLoading(true);
        return Bao.post("UadmCustom/RoleTab/AddRoleServiceProvider", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            serviceProviderId: serviceProviderId,
            roleId: roleId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.DeleteRoleServiceProvider = function (roleServiceProviderId) {
        return Bao.post("UadmCustom/RoleTab/DeleteRoleServiceProvider", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleServiceProviderId: roleServiceProviderId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.ShowServiceProviderTab = function (item) {
        if (item != null) {
            var newTab = new TabPage();
            newTab.Url("ServiceProvider");
            newTab.UrlData({
                id: item.ServiceProviderId
            });
            newTab.ObjectId(item.ServiceProviderId);
            AppTabController.AddTab(newTab);
        }
    };
    self.ShowRoleServiceProviderDialog = function () { };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedServiceProviderRow = ko.observable({});
    self.SelectedServiceProviderRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "RemoveServiceProviderFromRole":
                    button.Enabled(!(self.SelectedServiceProviderRow() == null));
                    break;
                case "AddServiceProviderToRole":
                    button.Enabled(!self.Role.IsNew());
                    break;
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("UadmCustom/RoleTab/ResetRoleServiceProvider", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("UadmCustom/RoleTab/SaveRoleServiceProviderCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.init = function () {
        return self.RefreshGrid();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
    self.Copy = function (roleId, saveTime) {
        return Bao.post("UadmCustom/RoleTab/CopyRoleServiceProviderCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            newRoleId: roleId,
            saveTime: saveTime
        }));
    };
}
;
export default RoleServiceProviderTabModel;